import $ from 'jquery'

export const checkAmznModals = () => {
  const modalTrigger = document.querySelector('div[data-modal-open]');
  const modalSelector = modalTrigger ? modalTrigger.dataset.modalOpen : null
  const modal = modalSelector ? document.querySelector(modalSelector) : null
  if (modal) {
    $(modal).modal('show')
  }
}

export const hideAllModals = () => {
  const list = [...document.querySelectorAll(".modal")]
  list.forEach((el) => {
    $(el).modal('hide')
  })
}